import AdminApi from '../services/api';
import AutocompleteObject from '../../src/components/Shared/AutocompleteObject';

import swal from 'sweetalert2';
import VueTimepicker from "vue2-timepicker";

import Autocomplete from "vuejs-auto-complete";
import AutocompleteVehicle from "../components/Shared/AutocompleteVehicle";

/* init */

const AdminApiService = new AdminApi()

export default{

    props: ['show', 'date'],

    data() {
        return {
            title: '',
            isLoading: false,
            isDisabledAddButton: false,
            drivers: [],
            vehicles: [],
            choosedTime: {HH: '08' , mm: '00'},
            newSelectedDriver: null,
            selectedVehicle: null,
            placeholderDriver: "Vozač",
            placeholderVehicle: "Vozilo",
            hasError: '',
            fromDate: null,
            displayDate: ''
        };
    },

    components: { AutocompleteObject, VueTimepicker },

    watch: {
        show: function(val, oldVal) {
            if(val === true){
                this.fromDate = this.date
                this.displayDate = this.$moment(new Date(this.fromDate )).format('DD-MM-YYYY')
            }
        },

    },

    methods: {
        close() {
            this.$topnavbar.$emit('closeAnotherShift')
        },
        successUpdate(){
            this.$topnavbar.$emit('successAnotherShift')
        },

        addSchedule: addSchedule,
        formatDate: formatDate,
        deleteVehicle: deleteVehicle,
        deleteDriver: deleteDriver,
        getVehicles: getVehicles,
        checkNullString: checkNullString,
        setNewVehicleInRow: setNewVehicleInRow,
        setNewDriver: setNewDriver,
        getDrivers: getDrivers,
        reset: reset,
    },

    beforeMount() {
        this.getDrivers();
        this.getVehicles();
    }
}

function deleteDriver(){
    this.newSelectedDriver = null;
}

function deleteVehicle(){
    this.selectedVehicle = null;
}

function setNewDriver(event) {
    if(event == null || event.length === 0){
        this.newSelectedDriver = null;
    }else{
        this.hasError = '';
        this.newSelectedDriver = event;
    }

}

function getVehicles() {
    var _self = this;
    AdminApiService.getVehicles()
        .then((response) => {
            _self.vehicles = response.data;
            _self.vehicles = response.data.map(e => {
                return {
                    id: e.id,
                    name: e.registrationPlate,
                    vehicle: e.name,
                    description: e.description,
                    averageSpending: e.averageSpending,
                    fuel: e.fuel,
                    kilometersTraveled: e.kilometersTraveled,
                    smallService: e.smallService,
                    lastSmallService: e.lastSmallService,
                }
            })
        })
        .catch((error) => {
            swal('Greška', error.data.localized_error_message, 'error')
        })
}

function setNewVehicleInRow(event) {
    if(event == null || event.length === 0){
        this.selectedVehicle = null;
    }else{
        this.hasError = '';
        this.selectedVehicle = event;
    }
}

function getDrivers() {
    var _self = this;
    var activeParams = "";
    AdminApiService.getDrivers(activeParams)
        .then((response) => {
            _self.drivers = []
            _self.drivers = response.data.map(e => {
                return {
                    id: e.id,
                    visibleVehicle: false,
                    vehicle: null,
                    choosedTime: {HH: '08' , mm: '00'},
                    name: e.lastName,
                    active: e.active,
                    firstName: e.firstName,
                    lastName: e.lastName,
                    freeDays: checkNullString(e.freeDays)
                }
            })
        })
        .catch((error) => {
            console.log(error);
            // swal('Greška', error.data.localized_error_message, 'error')
        })
}

function reset() {
    this.newSelectedDriver = null;
    this.selectedVehicle = null;
    this.choosedTime = {HH: '08' , mm: '00'};
}

function addSchedule(){
    let _self = this;
    if(this.newSelectedDriver == null) {
        this.hasError = "Molimo popunite sva polja";
        return;
    }

    var calendarTimestamp = Date.parse(_self.fromDate);
    if(isNaN(calendarTimestamp)){
        if(_self.isDateError == null){
            swal('Greška', 'Izaberite validan datum', 'error');
            _self.isDateError = 'notvalid'
        }

        return;
    }

    if(this.choosedTime.HH === "" || this.choosedTime.mm === ""){
        swal('Greška', 'Izaberite  početak smene', 'error');
        return;;
    }

    if(this.selectedVehicle == null){
        swal('Greška', 'Izaberite  tablice za vozača', 'error');
        return;;
    }

    let newModel = {
        courier: this.newSelectedDriver.id,
        vehicle: {
            id: this.selectedVehicle.id,
            registrationPlate: this.selectedVehicle.name,
            name: this.selectedVehicle.vehicle,
            description: this.selectedVehicle.description,
            averageSpending: this.selectedVehicle.averageSpending,
            fuel: this.selectedVehicle.fuel,
            kilometersTraveled: this.selectedVehicle.kilometersTraveled,
            smallService: this.selectedVehicle.smallService,
            lastSmallService: this.selectedVehicle.lastSmallService,
        },
        timestamp: calendarTimestamp,
        startShift: this.choosedTime.HH + ":" + this.choosedTime.mm
    }
    this.isDisabledAddButton = true;
    AdminApiService.createSchedules(newModel)
        .then((response) => {
            _self.$toasted.success('Uspešno otvorena smena',{ position: "top-right", duration: 2000})
            if(response.data.timestamps.length > 0){
                _self.$toasted.error(_self.newSelectedDriver.name+' ima nezatvorene smene za: ',{ position: "top-right", duration: 3000})
                response.data.timestamps.forEach(e => {
                    _self.$toasted.error(''+_self.formatDate(e),{ position: "top-right", duration: 3000})
                })
            }
            // swal('Uspešno', 'Uspešno kreiran raspored', 'success')
            _self.reset();
            _self.successUpdate();
            this.isDisabledAddButton = false;

        })
        .catch((error) => {
            console.log(error)
            this.isDisabledAddButton = false;
            swal('Greška', error.data.message, 'error')

        })

}

function formatDate(date) {
    return this.$moment(new Date(date )).format('DD-MM-YYYY')
}


function checkNullString(data) {
    if(data == null) return '';
    return data;
}


// WEBPACK FOOTER //
// ./src/modals/OpenAnotherShiftModal.js